export default "__VITE_ASSET__BcJ6dvtW__"